import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'cm-dp-blocklist',
  templateUrl: 'dp-blocklist.component.html',
  styles: [`
    ::ng-deep .mat-tab-labels {
      justify-content: center;
    }
  `]
})
export class DpBlocklistComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
